import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import { jsx } from 'react/jsx-runtime';
import * as Toast from '@radix-ui/react-toast';
import merge from 'lodash/merge';
import * as React from 'react';
import { useContext, useState } from 'react';
import { getUniqueId } from '../../utils/useUniqueId.js';
var DEFAULT_NOTIFICATION_DELAY = 5000;
var NotificationContext = /*#__PURE__*/React.createContext(null);

var useNotification = function useNotification() {
  var value = useContext(NotificationContext);

  if (!value) {
    throw new Error('useNotification should be wrapped inside NotificationProvider');
  }

  return value;
};
/**
 * A wrapper for notifications. It must be provided by the application.
 *
 * It provides a NotificationContext, which should be used with useNotification hook.
 * useNotification hook provides access to store, and methods to interact with it.
 */


var NotificationProvider = function NotificationProvider(props) {
  var children = props.children,
      rest = _objectWithoutProperties(props, _excluded);

  var _useState = useState(new Map()),
      _useState2 = _slicedToArray(_useState, 2),
      notifications = _useState2[0],
      setNotifications = _useState2[1];

  var addNotification = React.useCallback(function (args) {
    var variant = args.variant,
        styledText = args.styledText,
        sensitivity = args.sensitivity,
        closeButtonAriaLabel = args.closeButtonAriaLabel,
        typeIconAriaLabel = args.typeIconAriaLabel;
    var notificationId = getUniqueId();

    var onClose = function onClose(id) {
      return function () {
        setNotifications(function (oldValue) {
          var newValue = new Map(oldValue);
          newValue.delete(id);
          return newValue;
        });
      };
    };

    var newNotificationProps = _objectSpread(_objectSpread({}, args), {}, {
      key: notificationId,
      closeButtonAriaLabel: closeButtonAriaLabel,
      onClose: onClose(notificationId),
      sensitivity: sensitivity,
      styledText: styledText,
      typeIconAriaLabel: typeIconAriaLabel,
      variant: variant
    });

    setNotifications(function (oldNotifications) {
      return new Map(oldNotifications).set(notificationId, newNotificationProps);
    });
    return notificationId;
  }, []);
  var removeNotification = React.useCallback(function (id) {
    setNotifications(function (oldValue) {
      var newValue = new Map(oldValue);
      newValue.delete(id);
      return newValue;
    });
  }, []);
  var removeAllNotifications = React.useCallback(function () {
    setNotifications(new Map());
  }, []);
  var updateNotification = React.useCallback(function (id, newProps) {
    setNotifications(function (oldValue) {
      var newNotifications = new Map(oldValue);
      var oldNotificationProps = newNotifications.get(id);
      newNotifications.set(id, merge(oldNotificationProps, newProps));
      return newNotifications;
    });
  }, []);
  var store = React.useMemo(function () {
    return {
      addNotification: addNotification,
      notifications: notifications,
      removeNotification: removeNotification,
      updateNotification: updateNotification,
      removeAllNotifications: removeAllNotifications
    };
  }, [addNotification, removeNotification, notifications, updateNotification, removeAllNotifications]);
  return jsx(Toast.Provider, _objectSpread(_objectSpread({}, rest), {}, {
    duration: DEFAULT_NOTIFICATION_DELAY,
    children: jsx(NotificationContext.Provider, {
      value: store,
      children: children
    })
  }));
};

NotificationProvider.displayName = 'Notification.Provider';
export { NotificationProvider, useNotification };